import { map } from 'lodash';
import { connect } from 'react-redux';

import AddToCartModalRecommendations from 'components/AddToCartModalRecommendations';
import {
  CAMPAIGN_NAMES,
  PDP_ADD_TO_CART_MODAL_REC_OPTIONS,
  PERSONALIZATION_STATUS,
} from 'constants/personalizations';
import DYRecommendationsModel from 'models/DYRecommendations';
import * as actions from 'state/actions';
import CartSelector from 'state/selectors/cart';
import PersonalizationsSelector from 'state/selectors/personalizations';
import Money from 'utils/Money';
import Rudderstack from 'utils/Rudderstack';

const mapStateToProps = (state, ownProps) => {
  const { product, recommendationsOption } = ownProps;
  let recommendationProducts = [];
  const upsells = CartSelector.getCartUpsells(state)[0] || [];
  const campaignData = PersonalizationsSelector.getCampaignByName(
    state,
    CAMPAIGN_NAMES.PDP_ADD_TO_CART_MODAL_RECS
  );
  const variation = campaignData?.variations?.[0];

  if (recommendationsOption === PDP_ADD_TO_CART_MODAL_REC_OPTIONS.CONTENTFUL_UPSELLS) {
    map(upsells.slice(0, 4), upsell => {
      recommendationProducts.push({
        image: upsell.image,
        productName: upsell.productName,
        colorName: upsell.colorName,
        price: upsell.price,
        linkUrl: upsell.linkUrl,
      });
    });
  } else {
    const recommendationsCampaign = PersonalizationsSelector.getCampaignByName(
      state,
      recommendationsOption
    );
    if (recommendationsCampaign?.status === PERSONALIZATION_STATUS.SUCCESS) {
      const recommendationsData = new DYRecommendationsModel(recommendationsCampaign);

      map(recommendationsData.products, product => {
        const salePrice = product?.productData?.sale_price * 100;
        const originalPrice = product?.productData?.price * 100;
        const price = salePrice ? new Money(salePrice).format() : new Money(originalPrice).format();
        recommendationProducts.push({
          image: {
            alt: product?.productData?.name,
            src: product?.productData?.image_url,
          },
          productName: product?.productData?.name,
          colorName: product?.productData?.display_color,
          price,
          compareAtPrice: salePrice ? new Money(originalPrice).format() : null,
          linkUrl: product?.productData?.url,
          slotId: product?.slotId,
        });
      });
    }
  }

  const analyticsMetadata = variation?.analyticsMetadata;
  const analyticsData = {
    category: product?.type,
    name: product?.masterName,
    gender: product?.gender,
    handle: product?.handle,
    ...analyticsMetadata,
  };

  return {
    recommendations: recommendationProducts,
    analyticsData,
  };
};

const mapDispatchToProps = dispatch => ({
  trackRecommendationsClick: ({ analyticsProperties, slotId }) => {
    const { variationName } = analyticsProperties;

    Rudderstack.recommendationsClicked({
      ...analyticsProperties,
    });

    if (variationName !== PDP_ADD_TO_CART_MODAL_REC_OPTIONS.CONTENTFUL_UPSELLS) {
      dispatch(actions.reportDYRecsClick(slotId));
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddToCartModalRecommendations);
